import constants from "../constants";

const initialState = {
  isRegistered: false,
  allJobs: [],
  fetchingJobs: true,
  totalJobsCount: 0,
  jobDetail: {},
  allSkills: [],
  hasNoSkills: false,
  userSkills: [],
  allSkillsSubSet: [],
  isJobApplied: false,
  searchJobsCount: 0,
  applications: [],
  applicationDetail: {},
  allOffers: [],
  currentJobs: [],
  dashboardDetails: {},
  profileCompletion: "",
};

const consultantStore = (state = initialState, action) => {
  switch (action.type) {
    case constants.reducerActions.registered:
      return {
        ...state,
        isRegistered: action.isRegistered,
        token: action.token,
      };
    case constants.reducerActions.fetchingJobs:
      return {
        ...state,
        fetchingJobs: action.isFetching,
      };
    case constants.reducerActions.allJobs:
      return {
        ...state,
        totalJobsCount: action.totalJobsCount,
        fetchingJobs: action.isFetching,
        allJobs: [...action.jobs],
      };
    case constants.reducerActions.jobDetail:
      return {
        ...state,
        jobDetail: action.jobDetail,
      };
    case constants.reducerActions.skills:
      return {
        ...state,
        allSkills: action.allSkills,
        allSkillsSubSet: action.allSkills.slice(0, 5),
      };
    case constants.consultantActions.userSkills:
      return {
        ...state,
        userSkills: action.userSkills,
        fetchingJobs: action.isFetching,
      };
    case constants.consultantActions.jobApplied:
      return {
        ...state,
        isJobApplied: action.applied,
      };
    case constants.consultantActions.sliceSkills:
      return {
        ...state,
        allSkillsSubSet: state.allSkills.slice(0, action.length),
      };
    case constants.consultantActions.searchJobs:
      return {
        ...state,
        searchJobsCount: action.jobCount,
      };
    case constants.consultantActions.applications:
      return {
        ...state,
        applications: [...action.applications],
      };
    case constants.consultantActions.application:
      return {
        ...state,
        applicationDetail: action.applicationDetail,
      };
    case constants.consultantActions.allOffers:
      return {
        ...state,
        allOffers: [...action.offersList],
      };
    case constants.consultantActions.currentJobs:
      return {
        ...state,
        currentJobs: [...action.currentJobs],
      };
    case constants.consultantActions.dashboard:
      return {
        ...state,
        dashboardDetails: action.details,
      };
    case constants.consultantActions.profileCompletion:
      return {
        ...state,
        profileCompletion: action.profileCompletion,
      };
    default:
      return { ...state };
  }
};

export default consultantStore;
